import { render } from "./ButtonsComp.vue?vue&type=template&id=3edd8336"
import script from "./ButtonsComp.vue?vue&type=script&lang=js"
export * from "./ButtonsComp.vue?vue&type=script&lang=js"

import "./ButtonsComp.vue?vue&type=style&index=0&id=3edd8336&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__